export enum SortingOptions {
    NEWEST = 'newest',
    PRICE_ASC = 'priceAsc',
    PRICE_DESC = 'priceDesc',
}